import { z } from "zod";
import { config } from "../../config/client";

// Define valid plugin names using Zod
const PluginNameSchema = z.enum([
  "ToastManagerVanilla",
  "MenuPlugin",
  "CustomerInsightsPlugin",
  "TestIamPermissionsPlugin",
  "SenderRegistrationPlugin",
]);

type PluginName = z.infer<typeof PluginNameSchema>;

/**
 * Get the list of enabled plugins from the config, with validation
 */
export function getEnabledPlugins(): PluginName[] {
  const configPlugins = config.plugins;

  // Filter and validate plugin names
  const validPlugins = configPlugins
    .map((plugin) => {
      const result = PluginNameSchema.safeParse(plugin);
      if (!result.success) {
        console.warn(`Invalid plugin name in config: ${plugin}`);
        return null;
      }
      return result.data;
    })
    .filter((plugin): plugin is PluginName => plugin !== null);

  return validPlugins;
}
